module.exports = __webpack_public_path__ + "static/media/Self-Development_mob.4b25ff72.jpg";